module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-main"
  }, [_c('div', {
    staticClass: "header-main__nav"
  }, [_c('button', {
    staticClass: "header-main__item--logout button button--default-outline button--ripple",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitLogOut
    }
  }, [(_vm.loginLoading) ? _c('i', {
    staticClass: "fa fa-spinner"
  }) : _vm._e(), _vm._v(" "), (!_vm.loginLoading) ? _c('span', [_vm._v("Wyloguj się")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b3d9c4f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Panel/HeaderContainer/HeaderMain/index.vue
// module id = 745
// module chunks = 3